import THDStorageUtils, { LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';

export const calcArrHasValues = (arr) => {
  if (!arr.length) return true;
  return arr.some((el) => el !== '');
};

export const shouldClearStorage = (calculateObj) => {
  const { areas } = calculateObj;
  let shouldClearStorageBool = true;

  const depthArrHasNonDefaultValues = areas.some((el) => !['3', ''].includes(el.depth));
  const areaArrHasValues = areas.some((el) => el.squareFootage.value !== '');
  const calcValuesExist = ((areas.some((el) => el.name !== '' || el.length !== '' || el.width !== '')
    || depthArrHasNonDefaultValues
    || areaArrHasValues));

  if (calcValuesExist) shouldClearStorageBool = false;

  return shouldClearStorageBool;
};

export const formatStorageKey = (productInfo) => {
  if (!productInfo) return '';
  const { productDepartment = '', classNumber = '' } = productInfo;
  const DCS = `${productDepartment}-${classNumber}`;
  const storageKey = 'PIP-' + DCS;
  return storageKey;
};

export const getStorageObject = (storageKey) => {
  const storageValue = THDStorageUtils.get(LOCAL_STORAGE, { key: storageKey });
  const storageObject = storageValue !== 'undefined' ? JSON.parse(storageValue) : null;

  return storageObject;
};

export const saveStorageObject = (storageKey, calculate) => {
  const {
    calcByArea, calcByLengthWidth, step, toggleText, value, areas
  } = calculate;
  const storageObj = getStorageObject(storageKey);

  if (!storageObj && shouldClearStorage(calculate)) return;
  if (storageObj && shouldClearStorage(calculate)) {
    THDStorageUtils.remove(LOCAL_STORAGE, { key: storageKey });
  } else {
    THDStorageUtils.set(LOCAL_STORAGE, {
      key: storageKey,
      value: JSON.stringify({
        calcByArea,
        calcByLengthWidth,
        step,
        toggleText,
        value,
        areas
      })
    });
  }
};
